import * as S from "../ServiceToggleButton/styles";
import Home from "assets/Cards/home.svg";
import Car from "assets/Cards/car.svg";
interface Props {
  leftClick: React.MouseEventHandler<HTMLButtonElement>;
  response: boolean;
  rightClick: React.MouseEventHandler<HTMLButtonElement>;
  label: string;
  isEstablishment?: boolean;
  leftLabel: string;
  rightLabel: string;
}

export function OccurrenceToggleButton({
  label,
  leftClick,
  rightClick,
  isEstablishment,
  leftLabel,
  rightLabel,
}: Props) {
  return (
    <S.ToggleContainer>
      <label>{label}</label>
      <S.ToggleButton>
        <S.Button
          isActive={isEstablishment === true}
          onClick={leftClick}
          type="button"
        >
          {leftLabel}
          {leftLabel === "Residencial" && <img src={Home} alt="home" />}
        </S.Button>
        <S.Button
          isActive={isEstablishment === false}
          onClick={rightClick}
          type="button"
        >
          {rightLabel}
          {rightLabel === "Veículo" && <img src={Car} alt="vehicle" />}
        </S.Button>
      </S.ToggleButton>
    </S.ToggleContainer>
  );
}
